import React, { useEffect } from 'react';
import { IAny, ICoreContext, IGeneric, ITelemetry } from '@msdyn365-commerce/core';
import ErrorComponent from '../../../themes/hospitality/views/components/error.component';

interface SessionExpiredPageProps {
    context: ICoreContext<IGeneric<IAny>>;
    telemetry: ITelemetry;
    title: string;
    message: string;
    reason: string;
}

/** Sends a guest whose session has ended back to sign in, logging why once. */
export const SessionExpiredPage: React.FC<SessionExpiredPageProps> = ({ context, telemetry, title, message, reason }) => {
    useEffect(() => {
        telemetry.warning(`commerce-web-module: session ended (${reason})`);
    }, [reason, telemetry]);

    const countdownSeconds = Number(context.app.config.errorRedirectCountdownSeconds ?? 5);

    return (
        <ErrorComponent
            context={context}
            title={title}
            message={message}
            redirectUrl={context.app.config.errorRedirectUrl}
            countdownSeconds={Number.isFinite(countdownSeconds) ? countdownSeconds : 5}
        />
    );
};
